import { render, staticRenderFns } from "./DigitalPoolsForm.vue?vue&type=template&id=980e7ab8&scoped=true&"
import script from "./DigitalPoolsForm.vue?vue&type=script&lang=js&"
export * from "./DigitalPoolsForm.vue?vue&type=script&lang=js&"
import style0 from "./DigitalPoolsForm.vue?vue&type=style&index=0&id=980e7ab8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980e7ab8",
  null
  
)

export default component.exports